import { apiRequest } from "../http";
import { IResponse } from "../../types/response.type";

export interface GeoCountry {
	id?: string | number;
	criterion_id?: string | number;
	code?: string;
	name: string;
	country_code?: string;
}

export interface Language {
	code: string;
	name: string;
}

interface GeoCountriesSuccessData {
	ok: boolean;
	countries: GeoCountry[];
}

interface LanguagesSuccessData {
	ok: boolean;
	languages: Language[];
}

export interface ConversionAction {
	resource_name: string;
	id: number;
	name: string;
	status: string;
	type: string;
	category: string;
	origin: string;
	primary_for_goal: boolean;
}

interface ConversionsSuccessData {
	ok: boolean;
	conversions: ConversionAction[];
}

export type IGetGeoCountriesResponse = IResponse<GeoCountriesSuccessData>;
export type IGetLanguagesResponse = IResponse<LanguagesSuccessData>;
export type IGetConversionsResponse = IResponse<ConversionsSuccessData>;

export async function getGeoCountries(params: {
	buyer_id: number;
	customer_id: string;
}): Promise<IGetGeoCountriesResponse> {
	return await apiRequest<GeoCountriesSuccessData>({
		path: `/api/geo/countries?customer_id=${params.customer_id}&buyer_id=${params.buyer_id}`,
		method: "GET",
	});
}

export async function getLanguages(params: {
	buyer_id: number;
	customer_id: string;
}): Promise<IGetLanguagesResponse> {
	return await apiRequest<LanguagesSuccessData>({
		path: `/api/languages?customer_id=${params.customer_id}&buyer_id=${params.buyer_id}`,
		method: "GET",
	});
}

export async function getConversions(params: {
	app_id: string;
	buyer_id: number;
	customer_id: string;
}): Promise<IGetConversionsResponse> {
	const { app_id, customer_id, buyer_id } = params;
	return await apiRequest<ConversionsSuccessData>({
		path: `/api/conversions/${app_id}?customer_id=${customer_id}&buyer_id=${buyer_id}`,
		method: "GET",
	});
}
